import { BasePersonalFinancialStatementResource, PersonalFinancialStatementResourceType } from './basePersonalFinancialStatementResource'
import { getMostRecentDepositBalancesAsOfDate } from '@/services/personalFinancialStatement'
import { log } from '@/utils/logger'
import { RecordSnapshotRetrievalStrategy, DepositBalanceAsOfDateData } from 'aven_types'

export class PersonalFinancialStatementDepositBalanceAsOfDateResource extends BasePersonalFinancialStatementResource<PersonalFinancialStatementResourceType.DEPOSIT_BALANCE_AS_OF_DATE> {
    constructor() {
        super(PersonalFinancialStatementResourceType.DEPOSIT_BALANCE_AS_OF_DATE)
    }

    protected async fetchData(): Promise<DepositBalanceAsOfDateData[]> {
        log.info('PersonalFinancialStatementDepositBalanceAsOfDateResource.fetchData: Fetching deposit balances')

        const response = await getMostRecentDepositBalancesAsOfDate({
            snapshotDate: new Date(),
            sourceUniqueId: null,
            retrievalStrategy: RecordSnapshotRetrievalStrategy.SINGLE_SOURCE_WATERFALL_HIGHEST_RECORD_COUNT,
            rateLimitingOptions: {
                turnOffRateLimiter: false,
                onlyCountSuccessfulFetchesWhenRateLimiting: true,
            },
            fetchNewRecordSnapshotsOptions: {
                doNotFetchNewRecordsFromSource: false,
                fetchKeyStatusesFromSourceValues: true,
            },
        })

        log.info('PersonalFinancialStatementDepositBalanceAsOfDateResource.fetchData: Fetched %{count} deposit balances', { count: response.data.payload.length })

        return response.data.payload
    }
}
